import { render } from "./SnackbarNotification.vue?vue&type=template&id=e631fd40"
import script from "./js/snackbarNotification.js?vue&type=script&lang=js&external"
export * from "./js/snackbarNotification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__